import * as types from "./types";

export const bookingPluginsMutations = {
  [types.BOOKING_PLUGINS.SET.ALL](state, payload) {
    state.pluginsData = payload;
  }
};
